// removed by extract-text-webpack-plugin
module.exports = {"addRecipeWrapper":"Gfadaba","dropperContainer":"G11b145 Gac0c9a"};